const role = {
  root: "root",
  admin: "admin",
  reviewer: "reviewer",
  editor: "editor",
  reader: "reader",
  developer: "developer",
  anonymous: "anonymous",
};

export default role;
